import { useSiteConfig } from '@frontend/features/common/components/SiteConfigContext';
import { routes } from '@frontend/router/routes';
import { Navigate } from 'react-router-dom';

import { ProtectedRoute } from '../auth/components/ProtectedRoute';
import { isInboxEnabled } from './access';

interface InboxFeatureRouteProps {
  children: React.ReactNode;
}

export const InboxFeatureRoute = ({ children }: InboxFeatureRouteProps) => {
  const { settings } = useSiteConfig();

  if (!isInboxEnabled(settings?.featureFlags)) return <Navigate to={routes.error404} replace />;

  return (
    <ProtectedRoute action="manage" path="Cases">
      {children}
    </ProtectedRoute>
  );
};
